<template>
  <div>
    <BaseTable
      class="mt-5 table-shadow"
      :headers="headers"
      :items="infoStatusConsorcio"
      :loading="loading"
      :paginate="true"
      :search="search"
      sort-by="descrisao"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Status Consórcio</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <RegisterBottom
            v-can-access="1662"
            @click="(dialog = true), (labelBtn = 'Salvar')"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.acoes`]="{ item }">
        <!-- <v-btn
          icon
          v-can-access="1664"
          @click="editItem(item)"
          color="orange"
          dark
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          v-can-access="1665"
          icon
          @click="deleteItem(item)"
          class="ml-2"
          color="red"
          dark
          small
        >
          <v-icon>mdi-trash-can</v-icon>
        </v-btn>-->

        <IconBottom
          :name="'edit'"
          v-can-access="1664"
          @click="editItem(item)"
        />
        <IconBottom
          :name="'delete'"
          v-can-access="1665"
          @click="deleteItem(item)"
        />
      </template>
    </BaseTable>
    <ModalCadStatus
      :dialog="dialog"
      :labelBtn="labelBtn"
      :statusConsorcio="statusConsorcio"
      @close="refetch()"
    />
  </div>
</template>

<script>
import BaseTable from "@/components/shared/NewBaseTable.vue";
import RegisterBottom from "@/components/shared/bottons/RegisterBottom";
import comissao from "@/services/http/comissaoService";
import ModalCadStatus from "@/components/sistema/StatusConsorcio/ModalCadStatus";
import IconBottom from "@/components/shared/bottons/IconBottom";
export default {
  name: "Tabela",

  components: {
    BaseTable,
    RegisterBottom,
    IconBottom,
    ModalCadStatus
  },
  data() {
    return {
      loading: false,
      dialog: false,
      labelBtn: "Salvar",
      search: "",
      infoStatusConsorcio: [],
      statusConsorcio: {},
      headers: [
        { text: "ID", value: "id_status" },
        { text: "Descrição", value: "nome_status" },
        { text: "Status", value: "status" },
        { text: "Parcelas", value: "qtde_parc" },
        { text: "Ativos", value: "ativo" },
        { text: "Ações", value: "acoes", align: "center" }
      ]
    };
  },

  methods: {
    async fetchConsorcio(filter) {
      this.loading = true;
      const { data } = await comissao()
        .statusConsorcio()
        .show({
          per_page: -1,
          ...filter
        });
      this.infoStatusConsorcio = data.data;
      this.loading = false;
    },

    editItem(item) {
      this.statusConsorcio = Object.assign({}, item);
      this.dialog = true;
      this.labelBtn = "Editar";
    },
    async deleteItem(item) {
      try {
        await this.$swal.confirm(
          "Deletar Status Consórcio",
          `Deseja deletar Status Consórcio ${item.id_status}?`
        );
        comissao()
          .statusConsorcio(item.id_status)
          .delete(
            {},
            { notification: true, message: "Status Consórcio deletada" }
          );
        this.refetch();
      } catch (error) {
        this.$notify({
          type: "error",
          text: "Erro ao deletar Status Consórcio"
        });
      } finally {
        this.fetchConsorcio();
      }
    },

    async refetch() {
      this.dialog = false;
      await this.fetchConsorcio();
    }
  },

  mounted() {
    this.fetchConsorcio();
  }
};
</script>
